module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_postcardHover-d43a028b8501414a983bcb08eced2ce3.jpg";